const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/nutrition-plans/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/nutrition-plans/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { listNutritionPlansQuery } from '@/features/nutrition-plans/lib/list-nutrition-plans.query';
import { getLatestWeightQuery } from '@/features/weight-tracking/lib/get-latest-weight.query';
export const Route = createFileRoute('/_authenticated/settings/nutrition-plans/')({
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        nutritionPlanController: context.deps.controllers.nutritionPlanController,
        weightTrackingController: context.deps.controllers.weightTrackingController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureInfiniteQueryData(listNutritionPlansQuery(deps)), context.queryClient.ensureQueryData(getLatestWeightQuery(deps))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});